module.exports = __webpack_public_path__ + "img/insurancelogo1.8811ad8b.png";